import {ReactElement, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {IStore} from "../redux/defaultStore";
import {useSearchParams} from "react-router";
import {newReferralCode} from "../redux/affiliateReferrals/affiliateActions";

function ReferralHandler(): ReactElement {
    const dispatch = useDispatch();
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const reduxReferralCode = useSelector((store: IStore) => store.affiliateStore.referralCode);
    const reduxReferralExpiry = useSelector((store: IStore) => store.affiliateStore.referralExpiry);
    const [searchParams] = useSearchParams();
    const freshReferralCode = searchParams.get("ref");

    useEffect(() => {
        handleReferralId();
    }, [fullToken?.id, freshReferralCode, reduxReferralCode]);

    function handleReferralId() {
        let useReferralCode: string;
        if (freshReferralCode) {
            useReferralCode = freshReferralCode;
        } else if (reduxReferralCode && Date.now() < reduxReferralExpiry) {
            useReferralCode = reduxReferralCode;
        }

        if (!useReferralCode) {
            return;
        }

        if (!fullToken) {
            // If the user is not logged in, store the referral code in redux until they log in or sign up.
            dispatch(newReferralCode(useReferralCode));
        }
    }

    return null;
}

export default ReferralHandler;
